<template>
  <v-list class="add-box-viewer-list" flat>
    <v-list-item-group
      v-for="(member, index) in GET_REFER_USER_LIST"
      :key="index"
    >
      <v-list-item class="px-0" v-if="member.name" :ripple="false">
        <v-list-item-content>
          <v-list-item-title
            ><span class="name" v-text="member.name"></span
            ><span class="sub-desc ml-2" v-text="member.referJikchak"></span
            ><span class="sub-desc divider" v-text="member.referOrg"></span
          ></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider v-show="GET_REFER_USER_LIST.length - 1 > index"></v-divider>
    </v-list-item-group>
  </v-list>
</template>

<script>
/* 참조자 리스트 */
import { mapGetters } from 'vuex';

export default {
  data: () => ({}),
  computed: {
    ...mapGetters('ELA', ['GET_REFER_USER_LIST']),
  },
};
</script>

<style></style>
